import React, { useState } from 'react';
import { graphql, PageProps } from 'gatsby';
import Layout from 'src/elements/layout/layout';
import PricingPlansDetailsBanner from 'src/organisms/pricing/PricingPlansDetailsBanner';
import PricingPlanDetailsTableList from 'src/organisms/tables/PricinPlanDetails/PricingPlanDetailsTableList';
import { PricingDisplayMode } from 'src/elements/pricing/PricingBanner';

interface PricingPlanDetailsPageProps extends PageProps{
  data: {
    seoImage?: {
      file?: {
        url: string;
      };
    }
  }
}

const PricingPlanDetailsPage = (props: PricingPlanDetailsPageProps): JSX.Element => {
  const [ activePriceMode, setActivePriceMode ] = useState<PricingDisplayMode>('annual');

  const helmetData = {
    title: 'Mighty Networks | Pricing Plan Details',
    description: 'On a Mighty Network you can connect, livestream, teach, charge and more. Dig into our top features for anyone looking to build community and a Mighty Network Effect. Start your free trial now, no credit card required.',
    previewImageURL: props.data.seoImage?.file?.url
  }

  return (
    <Layout helmet={helmetData} location={props.location}>
      <PricingPlansDetailsBanner
        activePriceMode={activePriceMode}
        setActivePriceMode={setActivePriceMode}
      />
      <PricingPlanDetailsTableList activePriceMode={activePriceMode}/>
    </Layout>
  )
}

export const pageQuery = graphql`
  query PricingPlanDetailsPageQuery {
    seoImage: contentfulAsset(contentful_id: {eq: "42Yc34pKaIUgUkWN7iWzVB"}) {
      file {
        url
      }
    }
  }
`;

export default PricingPlanDetailsPage;
